// MST1020_R01 BOM 관련 유틸리티 함수 및 상수

import { allowedAccountsArr } from "src/components/common/common";
import { showWarning } from "src/utils/toast/toastUtil";
import { MST1060_R10Dto } from "./Dto_MST1060_R10";


export const headerNames_MST1060_R10: Record<string, string> = {
	rowIndex: "",
	barcode: '바코드',
	barcodeImage: '실제코드',
	itemCd: '품목코드',
	itemNm: '품목명',
	itemSpec: '품목규격',
	packQty: '포장수량',
	itemUnit: '포장단위',
	remark: '비고'
}

// 원본 데이터 복구 함수
export function restoreOriginalValues(
  valueIndex: number,
  originalData: MST1060_R10Dto,
  updateMST1060_R10List: (index: number, data: MST1060_R10Dto) => void,
  gridRef: any
) {
  setTimeout(() => {
    updateMST1060_R10List(valueIndex, {
      ...originalData,
      isModified: !originalData.inserted
    });
    if (gridRef.current?.api) {
      const allRowNodes: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        if (node.data?.valueIndex === valueIndex) {
          allRowNodes.push(node);
        }
      });
      if (allRowNodes.length > 0) {
        const targetNode = allRowNodes[0];
        targetNode.setDataValue('itemCd', originalData.itemCd);
        targetNode.setDataValue('itemNm', originalData.itemNm);
        targetNode.setDataValue('itemSpec', originalData.itemSpec);
        targetNode.setDataValue('itemUnit', originalData.itemUnit);
      }
    }
  }, 100);
}